import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { showToast } from "../../Infrastructure/Notifications/ToastrConfig";
import { resendActivationEmailAsync } from "../../Services/AccountService";
import {
  assignAdminClaimAsync,
  assignLearnerClaimAsync,
} from "../../Services/AdminService";
import { ADMIN, userIsInRole } from "../../Services/AuthService";
import {
  deleteUserAsync,
  getUserByUrlTokenAsync,
  updateUserAsync,
} from "../../Services/UserService";
import Card from "../../Shared/Components/Card/Card";
import Header from "../../Shared/Components/Header/Header";
import Modal from "../../Shared/Components/Modal/Modal";
import PrimaryButton from "../../Shared/Components/PrimaryButton/PrimaryButton";
import { validEmailRegex } from "./../../Infrastructure/Config/Regexes";

const AdminUser = () => {
  const { urlToken } = useParams();
  const [user, setUser] = useState({
    client: { name: "" },
    firstName: "",
    lastName: "",
    email: "",
    identityRole: { name: "" },
  });
  const [editMode, setEditMode] = useState(false);
  const history = useHistory();
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const getUser = async () => {
      let response = await getUserByUrlTokenAsync(urlToken);
      console.log(response);
      setUser(response.user);
    };
    getUser();
  }, [editMode, urlToken]);

  const handleValidation = () => {
    let fields = user;
    let errors = {};
    let formIsValid = true;

    //firstName
    if (!fields["firstName"]) {
      formIsValid = false;
      errors["firstName"] = "Please enter a first name";
    }

    //lastName
    if (!fields["lastName"]) {
      formIsValid = false;
      errors["lastName"] = "Please enter a last name";
    }

    //email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Please enter an email address";
    } else {
      if (!validEmailRegex.test(fields["email"])) {
        formIsValid = false;
        errors["email"] = "Please enter a valid email address";
      }
    }

    setErrors(errors);
    return formIsValid;
  };

  const updateUser = async () => {
    if (handleValidation()) {
      let respose = await updateUserAsync(user);
      if (respose.success) {
        showToast(true, "User updated");
        setEditMode(false);
      } else {
        showToast(false, respose.errors[0].error);
      }
    }
  };

  const deleteUser = async () => {
    let respose = await deleteUserAsync(user);
    if (respose.success) {
      showToast(true, "User deleted");
      history.goBack();
    } else {
      showToast(false, respose.errors[0].error);
    }
  };

  const resendConfirmationEmail = async () => {
    let data = {
      userId: user.id,
    };
    let response = await resendActivationEmailAsync(data);
    if (response.success) {
      showToast(true, "Email sent");
    } else {
      showToast(false, response.errors[0].error);
    }
  };

  const assignLearnerClaim = async () => {
    let data = {
      userId: user.id,
    };
    let response = await assignLearnerClaimAsync(data);
    if (response.success) {
      showToast(true, "Claim assigned");
    } else {
      showToast(false, response.errors[0].error);
    }
  };

  const assignAdminClaim = async () => {
    let data = {
      userId: user.id,
    };
    let response = await assignAdminClaimAsync(data);
    if (response.success) {
      showToast(true, "Claim assigned");
    } else {
      showToast(false, response.errors[0].error);
    }
  };

  const handleChange = (evt) => {
    setUser({ ...user, [evt.target.name]: evt.target.value });
  };

  return (
    <>
      <Header heading={user.firstName + " " + user.lastName} icon="user" />
      <div className="container-fluid content">
        <Card>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label>First name</label>
                <input
                  onChange={handleChange}
                  className="form-control"
                  name="firstName"
                  type="text"
                  disabled={!editMode}
                  value={user.firstName}
                />
                <small className="errorMessage">{errors.firstName}</small>
              </div>
              <div className="form-group">
                <label>Last name</label>
                <input
                  onChange={handleChange}
                  className="form-control"
                  name="lastName"
                  type="text"
                  disabled={!editMode}
                  value={user.lastName}
                />
                <small className="errorMessage">{errors.lastName}</small>
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  onChange={handleChange}
                  className="form-control"
                  name="email"
                  type="text"
                  disabled={!editMode}
                  value={user.email}
                />
                <small className="errorMessage">{errors.email}</small>
              </div>
              <div className="form-group">
                <label>Client</label>
                <input
                  className="form-control"
                  name="client"
                  type="text"
                  disabled={true}
                  value={user.client.name}
                />
              </div>
              <div className="form-group">
                <label>Group</label>
                <input
                  className="form-control"
                  name="group"
                  type="text"
                  disabled={true}
                  value={user.groupName || "No group assigned"}
                />
              </div>
              {!editMode ? (
                <PrimaryButton
                  func={() => {
                    setEditMode(true);
                  }}
                  text="Edit"
                  classes="float-right mt-2"
                />
              ) : (
                <>
                  <PrimaryButton
                    func={updateUser}
                    text="Save"
                    classes="float-right mt-2"
                  />
                  <PrimaryButton
                    func={() => {
                      setEditMode(false);
                    }}
                    text="Cancel"
                    classes="mr-3 float-right mt-2"
                  />
                </>
              )}
              {!editMode ? (
                <>
                  {!user.emailConfirmed && (
                    <PrimaryButton
                      classes="mt-2"
                      text="Resend confirmation"
                      func={resendConfirmationEmail}
                    />
                  )}
                  {userIsInRole(ADMIN) &&
                    user.identityRole.name !== "Learner" && (
                      <PrimaryButton
                        classes="mt-2 ml-2"
                        text="Assign learner role"
                        func={assignLearnerClaim}
                      />
                    )}
                  {userIsInRole(ADMIN) &&
                    user.identityRole.name !== "CLIENTADMIN" && (
                      <PrimaryButton
                        classes="mt-2 ml-2"
                        text="Assign admin role"
                        func={assignAdminClaim}
                      />
                    )}
                </>
              ) : (
                <button
                  data-toggle="modal"
                  data-target={`#delete`}
                  className="btn btn-danger mt-2"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </Card>
      </div>
      <Modal
        buttonFunc={deleteUser}
        modalId={"delete"}
        bodyText="Warning! Deleting users is ireversable! Are you sure you want to delete this user?"
        title={`Delete ${user.firstName} ${user.lastName}`}
        buttonText="Delete"
      />
    </>
  );
};

export default AdminUser;
